export default __webpack_public_path__ + "static/events-dark-ec109c32a38d84de64c1186badec19ff.png";